import { render } from "./ItemIndexBookStampRally.vue?vue&type=template&id=0c5d63fe&scoped=true"
import script from "./ItemIndexBookStampRally.vue?vue&type=script&lang=js"
export * from "./ItemIndexBookStampRally.vue?vue&type=script&lang=js"

import "./ItemIndexBookStampRally.vue?vue&type=style&index=0&id=0c5d63fe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0c5d63fe"

export default script